import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PrimaryButton } from '../../styledComponents/buttons';
import {
  CommonText,
  FormAlert,
  InputField,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from '../../styledComponents/common';
import { InfoSection } from './officesStyles';

const AddOffice = ({ createOffice, isLoading }) => {
  const [officeName, setOfficeName] = useState('');
  const [saveErrors, setSaveErrors] = useState({});
  const { t } = useTranslation();

  const onOfficeNameChange = e => {
    let errors = { ...saveErrors };
    delete errors['officeName'];
    setSaveErrors(errors);
    setOfficeName(e.target.value);
  };

  const handleSave = () => {
    let hasError = false;
    let errors = {};

    if (!officeName || officeName.trim() === '') {
      errors.officeName = t('office_name_required');
      hasError = true;
    }

    if (hasError) {
      setSaveErrors(errors);
      return;
    }

    // Call the create office function with just the name
    const payload = {
      name: officeName.trim(),
    };

    createOffice(payload);
  };

  return (
    <InfoSection>
      <CommonText name title fontSize="16px">
        {t('add_office_details')}
      </CommonText>

      <InputWithLabelSection margin="20px 0 0 0">
        <InputLabel>
          {t('office')}
          <RedStar>*</RedStar>
        </InputLabel>
        <InputField
          type="text"
          placeholder={t('type_office_name')}
          value={officeName}
          onChange={e => onOfficeNameChange(e)}
          style={
            saveErrors &&
            saveErrors[`officeName`] && {
              border: `1px solid #fe5969`,
              backgroundColor: `rgba(252, 87, 104, 0.05)`,
            }
          }
        />
        {saveErrors && saveErrors['officeName'] && (
          <FormAlert>{saveErrors['officeName']}</FormAlert>
        )}
      </InputWithLabelSection>

      <PrimaryButton
        onClick={handleSave}
        width="100%"
        margin="25px 0 0"
        disabled={isLoading}
      >
        {isLoading ? t('creating') : t('create_office')}
      </PrimaryButton>
    </InfoSection>
  );
};

export default AddOffice;
